export const SET_INTEGRATIONS = "setIntegrations";
export const CLEAR_INTEGRATIONS = "clearIntegrations";
export const SET_INTEGRATION = "setIntegration";
export const CLEAR_INTEGRATION = "clearIntegration";
export const SET_INTEGRATION_ID = "setIntegrationId";
export const CLEAR_INTEGRATION_ID = "clearIntegrationId";
export const SET_TOKEN = "setToken";
export const TOGGLE_INTEGRATION = "toggleIntegration";
export const SET_URL = "setUrl";
export const SET_NAME = "setName";
export const SET_PHONE = "setPhone";
export const SET_SENDER_KEY = "setSenderKey";
export const SET_NAMESPACE = "setNamespace";
export const SET_WORKSPACE_ID = "setWorkspaceId";
export const SET_WEBHOOK_URL = "setWebhookUrl";
export const SET_BROKER = "setBroker";
export const SET_EMAIL_INVITE_TEMPLATE_UUID = "setEmailInviteTemplateUuid";
export const SET_EMAIL_REMINDER_TEMPLATE_UUID = "setEmailReminderTemplateUuid";
export const SET_LINKSMS_INVITE_TEMPLATE_UUID = "setLinkSmsInviteTemplateUuid";
export const SET_LINKSMS_REMINDER_TEMPLATE_UUID = "setLinkSmsReminderTemplateUuid";
export const SET_THANKS_TEMPLATE_UUID = "setThanksTemplateUuid";
export const SET_EXPIRED_TEMPLATE_UUID = "setExpiredTemplateUuid";
export const SET_DEFAULT = "setDefault";
export const SET_SUBDOMAIN = "setSubdomain";
export const SET_EMAIL = "setEmail";
export const SET_HEALTH_SCORE_POSITIVE_TYPE = "setHealthScorePositiveType";
export const SET_HEALTH_SCORE_POSITIVE_PRIORITY = "setHealthScorePositivePriority";
export const SET_HEALTH_SCORE_POSITIVE_STATUS = "setHealthScorePositiveStatus";
export const SET_HEALTH_SCORE_POSITIVE_GROUP = "setHealthScorePositiveGroup";
export const SET_HEALTH_SCORE_NEUTRAL_TYPE = "setHealthScoreNeutralType";
export const SET_HEALTH_SCORE_NEUTRAL_PRIORITY = "setHealthScoreNeutralPriority";
export const SET_HEALTH_SCORE_NEUTRAL_STATUS = "setHealthScoreNeutralStatus";
export const SET_HEALTH_SCORE_NEUTRAL_GROUP = "setHealthScoreNeutralGroup";
export const SET_HEALTH_SCORE_NEGATIVE_TYPE = "setHealthScoreNegativeType";
export const SET_HEALTH_SCORE_NEGATIVE_PRIORITY = "setHealthScoreNegativePriority";
export const SET_HEALTH_SCORE_NEGATIVE_STATUS = "setHealthScoreNegativeStatus";
export const SET_HEALTH_SCORE_NEGATIVE_GROUP = "setHealthScoreNegativeGroup";
export const SET_HEALTH_SCORE_POSITIVE_ENABLED = "setHealthScorePositiveEnabled";
export const SET_HEALTH_SCORE_NEGATIVE_ENABLED = "setHealthScoreNegativeEnabled";
export const SET_HEALTH_SCORE_NEUTRAL_ENABLED = "setHealthScoreNeutralEnabled";
export const SET_SEND_ATTRIBUTES = "setSendAttributes";
export const SET_IS_TOKEN_VALID = "setIsTokenValid";
export const SET_GROUPS = "setGroups";
export const CLEAR_IS_TOKEN_VALID = "clearIsTokenValid";
export const CLEAR_GROUPS = "clearGroups";
export const SET_WHATSAPP_TEMPLATES = "setWhatsappTemplates";
export const CLEAR_WHATSAPP_TEMPLATES = "clearWhatsappTemplates";
